<div class="space-y-8">
  <!-- Header -->
  <div>
    <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
      {{ 'SETTINGS.PAGE_TITLE' | translate }}
    </h1>
    <p class="text-gray-600 dark:text-gray-400 mt-2">{{ 'SETTINGS.PAGE_SUBTITLE' | translate }}</p>
  </div>

  <div class="space-y-6">
    <!-- Tabs List -->
    <div class="overflow-x-auto -mx-1 pb-1">
      <div
        class="inline-flex h-10 items-center justify-center rounded-md bg-gray-100 dark:bg-gray-800 p-1 text-gray-500 dark:text-gray-400 mb-5 min-w-max"
      >
        <button
          (click)="setTab('profile')"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          [ngClass]="
            activeTab() === 'profile'
              ? 'bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm'
              : 'hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100'
          "
        >
          <lucide-icon [img]="User" class="w-4 h-4 mr-2"></lucide-icon>
          {{ 'SETTINGS.TABS.PROFILE' | translate }}
        </button>
        <!-- Don't delete this Notifications part, it can be used in the future. -->
        <!-- <button
          (click)="setTab('notifications')"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          [ngClass]="
            activeTab() === 'notifications'
              ? 'bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm'
              : 'hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100'
          "
        >
          <lucide-icon [img]="Bell" class="w-4 h-4 mr-2"></lucide-icon>
          {{ 'SETTINGS.TABS.NOTIFICATIONS' | translate }}
        </button> -->
        <button
          (click)="setTab('security')"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          [ngClass]="
            activeTab() === 'security'
              ? 'bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm'
              : 'hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100'
          "
        >
          <lucide-icon [img]="Lock" class="w-4 h-4 mr-2"></lucide-icon>
          {{ 'SETTINGS.TABS.SECURITY' | translate }}
        </button>
        <button
          (click)="setTab('billing')"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          [ngClass]="
            activeTab() === 'billing'
              ? 'bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm'
              : 'hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100'
          "
        >
          <lucide-icon [img]="CreditCard" class="w-4 h-4 mr-2"></lucide-icon>
          {{ 'SETTINGS.TABS.BILLING' | translate }}
        </button>
        <!-- vaqtinchalik yopildi o'chiib ketmasin -->

        <!-- <button
          (click)="setTab('preferences')"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          [ngClass]="
            activeTab() === 'preferences'
              ? 'bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm'
              : 'hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100'
          "
        >
          <lucide-icon [img]="Palette" class="w-4 h-4 mr-2"></lucide-icon>
          {{ 'SETTINGS.TABS.PREFERENCES' | translate }}
        </button> -->
        <button
          (click)="setTab('currency')"
          class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          [ngClass]="
            activeTab() === 'currency'
              ? 'bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm'
              : 'hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100'
          "
        >
          <lucide-icon [img]="Coins" class="w-4 h-4 mr-2"></lucide-icon>
          {{ 'SETTINGS.TABS.CURRENCY' | translate }}
        </button>
      </div>
    </div>

    <!-- Profile Tab -->
    @if (activeTab() === 'profile') {
      <app-settings-profile />
    }

    <!-- Notifications Tab -->
    @if (activeTab() === 'notifications') {
      <app-settings-notifications />
    }

    <!-- Security Tab -->
    @if (activeTab() === 'security') {
      <app-settings-security />
    }

    <!-- Billing Tab -->
    @if (activeTab() === 'billing') {
      <app-settings-billing />
    }

    <!-- vaqtinchalik yopildi o'chiib ketmasin -->
    <!-- Preferences Tab -->
    <!-- @if (activeTab() === 'preferences') {
      <app-settings-preferences />
    } -->

    <!-- Currency Tab -->
    @if (activeTab() === 'currency') {
      <app-settings-currency />
    }
  </div>
</div>
